/**
 * Parses the query string out of a Next.js `router.asPath` (e.g. `/foo?a=1#hash`) into
 * `URLSearchParams`. `asPath` is a path-relative string, not a full URL, so it can't be handed
 * to `new URL()` directly -- split on `?`/`#` ourselves rather than pulling in a full URL parser
 * for something this small.
 *
 * Prefer this (plus `router.isReady`) over `router.query` wherever the query string must reflect
 * the actual browser URL rather than whatever Next hydrated with -- see `useCmsPreviewVersionId`
 * for the concrete CDN-caching failure mode this avoids.
 */
export function parseAsPathSearchParams(asPath: string): URLSearchParams {
  const queryAndHash = asPath.split('?')[1] ?? '';
  const queryOnly = queryAndHash.split('#')[0];
  return new URLSearchParams(queryOnly);
}
